<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="areas"
      :loading="loading"
      item-key="name"
      class="table-rounded datatable-height"
      fixed-header
      disable-sort
    >
      <!-- icon -->
      <template #[`item.icon`]="{ item }">
        <div class="icon-service center-sub-items">
          <img draggable="false" :src="loadImage(item.icon)" :alt="item.text" />
        </div>
      </template>
      <!-- name -->
      <template #[`item.text`]="{ item }">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.text }}</span>
          <!-- <small>{{ item.post }}</small> -->
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="d-flex">
          <CrudButtons @edit="$emit('edit', item)" @remove="$emit('remove', item)"></CrudButtons>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CrudButtons from '@/components/buttons/CrudButtons.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    CrudButtons,
  },
  props: {
    areas: Array,
    search: String,
    loading: Boolean,
  },
  setup() {
    const statusColor = {
      Activo: 'primary',
      Inactivo: 'error',
    }

    const loadImage = src => {
      return loadAPIImage(src)
    }

    return {
      loadImage,
      headers: [
        { text: 'ICONO', value: 'icon' },
        { text: 'RUBRO', value: 'text' },
        { text: 'DESCRIPCION CORTA', value: 'description' },
        { text: 'URL', value: 'urlText' },
        { text: 'FECHA REGISTRO', value: 'created_at' },
        { text: 'ULTIMA ACTUALIZACION', value: 'updated_at' },
        { text: '', value: 'actions', align: 'right' },
      ],
      status: {
        1: 'Activo',
        2: 'Inactivo',
        //3: 'Rechazado',
      },
      statusColor,
    }
  },
}
</script>

<style lang="scss" scoped>
.icon-service {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #00aca0;
  padding: 10px;
  margin: 10px;
}

.icon-service img {
  max-width: 50px;
  max-height: 50px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>